<template>
  <el-dialog
    :title="(userId === null ? $t('common.create') : $t('common.update')) + ' ' + $t('common.user')"
    :visible.sync="showDialog"
    @open="loadUser"
    @close="closeDialog"
    width="500px"
    autoComplete="false"
    :close-on-click-modal="false"
  >
      <el-form v-loading="loading"
               ref="form"
               :model="form"
               :rules="rules"
               size="small"
               label-width="140px"
               label-position="left">
          <el-form-item :label="$t('masters.userName')"
                        prop="userName">
              <el-input v-model="form.userName"
                        autoComplete="new-password"></el-input>
          </el-form-item>
          <el-form-item :label="$t('common.name')"
                        prop="name">
              <el-input v-model="form.name"
                        autoComplete="new-password"></el-input>
          </el-form-item>
          <el-form-item :label="$t('common.email')"
                        prop="email">
              <el-input v-model="form.email"
                        autoComplete="new-password"></el-input>
          </el-form-item>
          <el-form-item :label="$t('masters.isReadOnly')"
                        prop="role">
              <el-switch v-model="form.isReadOnly"></el-switch>
          </el-form-item>

          <el-form-item :label="$t('masters.isSuperAdmin')"
                        prop="role">
              <el-switch v-model="form.isSuperAdmin"></el-switch>
          </el-form-item>
          <el-form-item :label="$t('common.phone')"
                        prop="phoneNumber">
              <el-input v-model="form.phoneNumber"
                        autoComplete="new-password"></el-input>
          </el-form-item>
          <el-form-item :label="$t('common.address')"
                        prop="address">
              <el-input v-model="form.address"
                        autoComplete="new-password"></el-input>
          </el-form-item>
      </el-form>
    <span slot="footer">
      <el-button
        :disabled="loading"
        v-if="userId !== null"
        @click="resetPassword"
      >{{$t('common.resetPassword')}}</el-button>
      <el-button
        :disabled="loading"
        type="primary"
        @click="save"
      >{{userId === null ? $t('common.create') : $t('common.update')}}</el-button>
      <el-button
        :disabled="loading"
        @click="closeDialog"
      >{{$t('common.cancel')}}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { RoleSelector } from "@/app/shared/components";
import api from "../api";
export default {
  name: "create-update-user-dialog",
  components: {
    RoleSelector
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    userId: {
      required: false
    }
  },
  data() {
    return {
      form: {
        userName: "",
        name: "",
        email: "",
        isReadOnly: false,
        isSuperAdmin: false,
        phoneNumber: "",
        address: ""
      },
      rules: {
        userName: [
          {
            required: true,
            message: this.$t('common.pleaseEnterUsername'),
            trigger: "blur"
          }
        ],
        email: [
          {
            required: true,
            message: this.$t('common.pleaseEnterEmail'),
            trigger: "blur"
          }
        ],
        phoneNumber: [
          {
            required: true,
                message: this.$t('common.pleaseEnterPhoneNumber'),
            trigger: "blur"
          }
        ],
        address: [
          {
            required: true,
            message: this.$t('common.pleaseEnterAddress'),
            trigger: "blur"
          }
        ]
      },
      showDialog: this.visible,
      loading: false
    };
  },
  watch: {
    visible: function(val) {
      this.showDialog = val;
    }
  },
  methods: {
    loadUser() {
      if (this.userId) {
        this.loading = true;
        api.getUser(this.userId).then(response => {
          this.loading = false;
          this.form = Object.assign({}, response.data);
        });
      }
    },
    closeDialog() {
      this.$refs["form"].resetFields();
      this.showDialog = false;
      this.loading = false;
      this.$emit("dialogClosed");
    },
    save() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          this.loading = true;
          api
            .saveUser(this.userId, this.form)
            .then(response => {
              this.$emit("save", {
                new: this.userId === undefined,
                id: this.userId,
                data: this.form
              });
              this.closeDialog();
            })
            .catch(err => {
              if (err && err.response && err.response.data) {
                this.$message({
                  type: "error",
                  message: err.response.data[""][0]
                });
                this.loading = false;
              }
            });
        } else {
          return false;
        }
      });
    },
    resetPassword() {
      this.$confirm(this.$t('common.areYouSure'), "Warning", {
        confirmButtonText: this.$t('common.OK'),
        cancelButtonText: this.$t('common.cancel'),
        type: "warning"
      })
        .then(() => {
          api.resetPassword(this.userId).then(() => {
            this.$message({
              type: "success",
                message: this.$t('common.emailWithInstructionsWasSent')
            });
          });
        })
        .catch(_ => {});
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// ClientApp/app/masters/users/components/CreateUpdateUserDialog.vue